<script setup>
defineProps({
  size: {
    type: String,
    required: false,
    default: 'default',
  },
})
</script>

<template>
  <div
    class="mx-auto w-full px-4 sm:px-6"
    :class="{
      'max-w-[57rem]': size === 'sm',
      'max-w-5xl': size === 'md',
      'max-w-7xl': size === 'default',
    }"
  >
    <slot />
  </div>
</template>
